<template>
  <div class="form-check form-switch d-flex align-items-center">
    <input
      v-if="model"
      :class="`switch-${color}`"
      class="form-check-input me-2"
      type="checkbox"
      :id="id"
      @change.prevent="handleChange($event)"
      :checked="checked"
      v-model="model.$model"
    />
    <input
      v-else-if="readonly"
      :class="`switch-${color}`"
      class="form-check-input me-2"
      type="checkbox"
      :id="id"
      :checked="checked"
      :onclick="handleChange"
    />
    <input
      v-else
      :class="`switch-${color}`"
      class="form-check-input me-2"
      type="checkbox"
      :id="id"
      :checked="checked"
      @change.prevent="handleChange($event)"
    />
    <label
      v-if="label"
      :class="`text-${color}`"
      :for="id"
      class="form-check-label text-subtitle"
      >{{ label }}</label
    >
    <div
      v-if="loading"
      class="ms-3 spinner-border spinner-border-sm"
      :class="`text-${color}`"
      role="status"
    ></div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    id: string;
    label?: string;
    color?: string;
    loading?: boolean;
    checked?: boolean;
    readonly?: boolean;
    model?: any;
  }>(),
  {
    color: "primary",
    loading: false,
    checked: false,
    readonly: false,
    model: () => ({}),
  },
);

const emit = defineEmits<{
  handleChange: [event?: any];
}>();

const handleChange = (event?: any) => {
  if (props.readonly) {
    emit("handleChange");
    return false;
  }
  emit("handleChange", event);
};
</script>

<style scoped lang="scss">
@import "@/assets/theme/scss/user-variables";

.switch-primary.form-check-input:checked {
  background-color: $primary !important;
}
.switch-success.form-check-input:checked {
  background-color: $success !important;
}
.switch-secondary.form-check-input:checked {
  background-color: $secondary !important;
}
.switch-primary.form-check-input,
.switch-primary.form-check-input:focus:not(:checked) {
  background-color: $primary25 !important;
}
.switch-success.form-check-input,
.switch-success.form-check-input:focus:not(:checked) {
  background-color: $success25 !important;
}
.switch-secondary.form-check-input,
.switch-secondary.form-check-input:focus:not(:checked) {
  background-color: $secondary25 !important;
}
</style>
